import { BrowserMultiFormatReader } from '@zxing/browser';
import { createMembershipBarcodeHints } from './barcode-decode-hints.util';

/** Decode the first barcode/QR code found in an image file, or null if none / decode fails. */
export async function tryDecodeBarcodeFromImageFile(file: File): Promise<string | null> {
  if (typeof URL === 'undefined' || !file) {
    return null;
  }

  let objectUrl: string | null = null;
  try {
    objectUrl = URL.createObjectURL(file);
    const codeReader = new BrowserMultiFormatReader(createMembershipBarcodeHints());
    const result = await codeReader.decodeFromImageUrl(objectUrl);
    const text = result?.getText()?.trim();
    return text || null;
  } catch {
    return null;
  } finally {
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl);
    }
  }
}
